import React, { useState, useEffect, useRef } from 'react';
import CountryPicker from '../../countryPicker/CountryPicker';
import { Link } from 'react-router-dom';

const SecondaryNav = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const menuRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };
    
    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen]);
  
  const toggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  
  return (
    <div className="w-full bg-white">
      {/* Desktop Navigation */}
      <nav className="max-w-screen-xl mx-auto px-4">
        <div className="hidden md:flex justify-between items-center h-12">
          <div className="flex space-x-8">
            <Link to="/" className="text-gray-600 hover:text-gray-900">
              Home
            </Link>
            <Link to="/contact/?selected-tab=faqs" className="text-gray-600 hover:text-gray-900">
              FAQs
            </Link>
            <Link to="/blog" className="text-gray-600 hover:text-gray-900">
              Blog
            </Link>
          </div>
          
          <div className="flex items-center">
            <CountryPicker />
          </div>
        </div>
        
        {/* Mobile Navigation */}
        <div className="md:hidden flex justify-between items-center h-12">
          <div>
            <button
              type="button"
              className="text-gray-600 hover:text-gray-900"
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <svg className="h-6 w-6" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                <path d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>
            </button>
          </div>
          
          <div className="flex items-center">
            <CountryPicker />
          </div>
        </div>
        
        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setIsMobileMenuOpen(false)} />
        )}
        <div
          ref={menuRef}
          className={`fixed top-0 left-0 bottom-0 w-64 bg-white z-50 transform transition-transform duration-300 ease-in-out ${
            isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
          }`}
        >
          <div className="p-4">
            <button
              className="text-gray-600 hover:text-gray-900"
              onClick={() => setIsMobileMenuOpen(false)}
              aria-label="Close menu"
            >
              <svg className="h-6 w-6" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                <path d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
          <div className="p-4 flex flex-col space-y-4">
            <Link to="/" className="text-gray-600 hover:text-gray-900">
              Home
            </Link>
            {/* <Link to="/" className="text-gray-600 hover:text-gray-900">
              Brands
            </Link> */}
            <Link to="/contact/?selected-tab=faqs" className="text-gray-600 hover:text-gray-900">
              FAQs
            </Link>
            <Link to="/blog" className="text-gray-600 hover:text-gray-900">
              Blog
            </Link>
            {/* <Link to="/" className="text-gray-600 hover:text-gray-900">
              Wishlists
            </Link> */}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default SecondaryNav;